import { Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { VyIcon } from '@vy/ui-design-system';
import { AWS_REGIONS } from '@vy/types';
import { isNotEmptyString } from '@vy/utils';
import { useState, type FC } from 'react';
import { useWatch, type Control } from 'react-hook-form';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { nord } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { ControlledAutocomplete } from '../../../components/ControlledAutocomplete';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { S3RegisterFormValues } from '../S3RegisterFormSchema';
import { generateCloudFormationTemplate } from '../utils/generate-cloud-formation-template';

export const S3RegistrationForm: FC<{ control: Control<S3RegisterFormValues> }> = ({ control }) => {
  const account = localStorage.getItem('accountId');
  const [template, setTemplate] = useState('');
  const { region, bucketName } = useWatch({ control });

  return (
    <FormContainer>
      <LogoContainer>
        <VyIcon
          icon="AwsLogoIcon"
          style={{
            transform: 'scale(0.5)',
            transformOrigin: 'top left',
          }}
        />
      </LogoContainer>
      <Typography variant="h4">Enter the following fields to get started</Typography>
      <ControlledTextInput name="bucketName" control={control} label="Bucket Name" />
      <ControlledAutocomplete
        name="region"
        label="Region"
        control={control}
        options={AWS_REGIONS}
        placeholder="Select region"
      />
      <Button
        variant="contained"
        onClick={() => setTemplate(generateCloudFormationTemplate(account ?? undefined, region, bucketName))}
      >
        Generate Cloud Formation
      </Button>
      {isNotEmptyString(template) && (
        <SyntaxHighlighter language="yaml" style={nord} showLineNumbers={true} wrapLines={true}>
          {template}
        </SyntaxHighlighter>
      )}
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
